export const getOutFalseValues = Boolean as any as <T>(x: T | null | undefined) => x is T;
